module.exports = __webpack_public_path__ + "img/coupon_frame1.f805e91b.png";